import { loadStripe } from '@stripe/stripe-js'

export default async ({ Vue }) => {
  const stripe = await loadStripe(process.env.STRIPE)

  Vue.prototype.$stripe = stripe
}
